module.exports = __webpack_public_path__ + "img/intelligent-forecasting.f4476e88.png";